import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  header: {
    backgroundColor: themeColor.white,
    height: '9vh',
    marginBottom: '5vh',
    fontSize: vh(2.28),
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
  },
  icon: {
    borderRadius: '50%',
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  decision: {
    color: theme.palette.secondary.main,
  },
  message: {
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: vh(4),
    marginBlockStart: '0',
    width: '90%',
    padding: '0 5%',
    color: themeColor.defaultTextColor,
    textAlign: 'center',
  },
  subMessage: {
    lineHeight: '1.56',
    color: themeColor.subheaderLight,
    fontSize: vh(2.4),
  },
  messageWrapper: {
    height: '8.85vh',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  displayBody: {
    flex: '1 1 0',
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },

  list: {
    display: 'block',
    paddingLeft: '11vw',
    paddingRight: '11vw',
  },
  listItem: {
    height: '6.5vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    fontSize: vh(2),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: rem(1.33),
    letterSpacing: '0.17px',
    color: themeColor.almostblack,
    paddingLeft: '1.02vw',
    paddingRight: '1.02vw',
    '@media (min-height: 700px) and (max-height: 899px)': {
      height: '6.3vh',
    },
    '@media (min-height: 768px) and (max-height: 900px)': {
      height: '6.5vh',
    },
    '@media (min-height: 900px) and (max-height: 1079px)': {
      height: '6.8vh',
    },
    '@media (min-height: 1080px) and (max-height: 1199px)': {
      fontSize: rem(1.125),
      height: '7.4vh',
    },
    '@media (min-height: 1200px) and (min-width: 1200px) and (aspect-ratio:4/3)': {
      height: '7.4vh',
    },
    '@media (min-height: 1080px) and (min-width: 1920px) and (aspect-ratio:16/9)': {
      fontSize: rem(1.525),
      height: '7.2vh',
    },
  },
  selectListBottomContainer: {
    marginBottom: '3vh',
    height: '9.24vh',
    paddingLeft: '1.17vw',
    paddingRight: '1.17vw',
  },

  closeButton: {
    fontSize: vh(2.08),
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  confirmButton: {
    fontSize: vh(2.08),
    '&.Mui-disabled': {
      backgroundColor: themeColor.progressBar,
      color: themeColor.subheaderLight,
      opacity: 1,
    },
  },
  selected: {
    borderRadius: '2px',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  badge: {
    paddingTop: '1.8vh',
  },
  listContainer: {
    height: '45vh',
  },
}));
